import { render, staticRenderFns } from "./transferAccounts.vue?vue&type=template&id=ef0ee828&scoped=true"
import script from "./transferAccounts.vue?vue&type=script&lang=js"
export * from "./transferAccounts.vue?vue&type=script&lang=js"
import style0 from "./transferAccounts.vue?vue&type=style&index=0&id=ef0ee828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0ee828",
  null
  
)

export default component.exports